import type { SVGProps } from "react";
export default function SvgGenericAppNoShadow(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 130 124"
			{...props}
		>
			<g filter="url(#filter0_i_1110_710)">
				<path
					fill="url(#paint0_linear_1110_710)"
					fillOpacity={0.6}
					stroke="url(#paint1_linear_1110_710)"
					d="M27.138 22.959h48.414a4.34 4.34 0 0 1 4.342 4.342v69.857a4.34 4.34 0 0 1-4.342 4.342H27.138a4.34 4.34 0 0 1-4.342-4.342V27.301a4.34 4.34 0 0 1 4.342-4.342Z"
				/>
			</g>
			<g filter="url(#filter1_i_1110_710)">
				<path
					fill="white"
					fillOpacity={0.01}
					d="M89.634 33.836v54.86a4.84 4.84 0 0 1-4.842 4.843H36.378a4.84 4.84 0 0 1-4.842-4.842V18.842A4.84 4.84 0 0 1 36.378 14h33.438l19.815 19.836z"
				/>
				<path
					stroke="url(#paint2_linear_1110_710)"
					strokeOpacity={0.5}
					d="M36.377 14.5H69.61l19.524 19.545v54.651a4.34 4.34 0 0 1-4.341 4.343H36.377a4.34 4.34 0 0 1-4.341-4.343V18.842a4.34 4.34 0 0 1 4.341-4.342Z"
				/>
			</g>
			<g filter="url(#filter2_ddddi_1110_710)">
				<path
					fill="white"
					fillOpacity={0.01}
					stroke="url(#paint3_linear_1110_710)"
					d="M88.495 33.439H74.977a4.68 4.68 0 0 1-4.683-4.675V15.208z"
				/>
			</g>
			<path
				fill="#FAFF00"
				d="M79.726 49.268h-38.28a2.114 2.114 0 1 1 0-4.23h38.283a2.114 2.114 0 1 1 0 4.23z"
			/>
			<path
				fill="#FAFF00"
				d="M79.726 62.046h-38.28a2.114 2.114 0 1 1 0-4.23h38.283a2.114 2.114 0 1 1 0 4.23z"
			/>
			<path
				fill="#FAFF00"
				d="M79.726 74.824h-38.28a2.114 2.114 0 1 1 0-4.23h38.283a2.114 2.114 0 1 1 0 4.23z"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_1110_710"
					x1={51.4935}
					x2={51.4935}
					y1={22.459}
					y2={102}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1110_710"
					x1={51.3453}
					x2={16.297}
					y1={23.3301}
					y2={80.2203}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_1110_710"
					x1={60.5846}
					x2={60.5846}
					y1={14}
					y2={93.5387}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<linearGradient
					id="paint3_linear_1110_710"
					x1={79.7493}
					x2={72.3805}
					y1={14.2184}
					y2={30.5707}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<filter
					id="filter0_i_1110_710"
					width={94.0977}
					height={115.541}
					x={4.29639}
					y={4.45898}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect1_innerShadow_1110_710" />
				</filter>
				<filter
					id="filter1_i_1110_710"
					width={94.0977}
					height={115.539}
					x={13.5356}
					y={-4}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect1_innerShadow_1110_710" />
				</filter>
				<filter
					id="filter2_ddddi_1110_710"
					width={99.9097}
					height={127.938}
					x={29.7944}
					y={-4}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1110_710" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.027451 0 0 0 0 0.109804 0 0 0 0 0.152941 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1110_710"
						result="effect2_dropShadow_1110_710"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1110_710"
						result="effect3_dropShadow_1110_710"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1110_710"
						result="effect4_dropShadow_1110_710"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1110_710" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1110_710" />
				</filter>
			</defs>
		</svg>
	);
}
